module.exports = __webpack_public_path__ + "img/Jess_and_I_beach.bcd163f6.jpeg";